import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { MyTeamsAccessService } from '../components/myTeam/myTeam-utilities/my-teams-access.service';

/**
 * Blocks My Team when the environment flag is off or the user has no
 * Team+Project / Team Tracker / Feedback view actions.
 */
export const myTeamModuleGuard: CanActivateFn = () => {
  const access = inject(MyTeamsAccessService);
  access.refresh();
  if (!access.canViewModule()) {
    return inject(Router).createUrlTree(['/dashboard', 'home']);
  }
  return true;
};
